import { useState, useCallback, useEffect } from 'react';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { AUTO_PLAY_INTERVAL } from './HeadToToeWeddingSection.constants';

export const useHeadToToeWeddingSectionController = (numberOfSlides: number) => {
  const isMobile = useThemeMediaQuery('below_sm');
  const [activeSlide, setActiveSlide] = useState(0);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isMouseHover, setIsMouseHover] = useState(false);
  const handleOnLeave = useCallback(() => setIsMouseHover(false), []);
  const handleOnHover = useCallback((index: number) => {
    setIsMouseHover(true);
    setActiveSlide(index);
  }, []);
  const handleBeforeSlide = useCallback(
    (currentSlide: number, nexSlide: number) => !isMouseHover && !isMobile && setActiveSlide(nexSlide),
    [isMobile, isMouseHover]
  );
  const handleAfterSlide = useCallback(
    (prevSlide: number) => setIsLastSlide(numberOfSlides === prevSlide + 1 && !isMouseHover && !isMobile),
    [isMobile, isMouseHover, numberOfSlides]
  );
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (isLastSlide) {
      timeout = setTimeout(() => setActiveSlide(0), AUTO_PLAY_INTERVAL);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [isLastSlide]);
  return {
    activeSlide,
    isMouseHover,
    handleOnHover,
    handleOnLeave,
    handleBeforeSlide,
    handleAfterSlide,
  };
};
